// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content[data-v-4382d4a6] {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-result[data-v-4382d4a6] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  top: 10%;
}
.error-message[data-v-4382d4a6] {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.scan-box[data-v-4382d4a6] {
  border: 1px solid #fff;
  border-radius: 10%;
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  left: 50%;
  height: 300px;
  position: absolute;
  top: 40%;
  transform: translate(-50%, -50%);
  width: 300px;
  z-index: 1;
}
.action-buttons[data-v-4382d4a6] {
  position: absolute;
  padding: 0 10px;
  width: 100%;
  z-index: 2;
  bottom: 10px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
